// Icon atom component
export const Icon = ({ children, className = "", size = "md", ...props }) => {
  const sizes = {
    sm: "text-2xl",
    md: "text-3xl",
    lg: "text-5xl",
  };

  return (
    <span className={`${sizes[size]} ${className}`} {...props}>
      {children}
    </span>
  );
};
